<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {network, parameter} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import {decode, encode} from "../../../helpers";


    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    const motori = options.motor || {
        'Novo N21 220В': 'Novo N21 220В',
        'Novo N21 220В Wi-fi': 'Novo N21 220В Wi-fi',
        'Novo N21 АКБ': 'Novo N21 АКБ',
        'Novo N18 220В': 'Novo N18 220В',
        'Без мотора': 'Без мотора',

    }
    const upr = options.upr || {

        'Пульт Novo А13 (6 каналов)': 'Пульт Novo А13 (6 каналов)',
        'Пульт Novo А6 (9 каналов)': 'Пульт Novo А6 (9 каналов)',
        'Пульт Novo А6 (99 каналов)': 'Пульт Novo А6 (99 каналов)',

    }

    const dop_upr = options.dop_upr || {

        'Кнопка Novo А9 (1 канал белая)': 'Кнопка Novo А9 (1 канал белая)',
        'Кнопка Novo А9 (2 канала белая)': 'Кнопка Novo А9 (2 канала белая)',
        'Кнопка Novo А9 (1 канал черная)': 'Кнопка Novo А9 (1 канал черная)',
        'Кнопка Novo А9 2 (канал черная)': 'Кнопка Novo А9 2 (канал черная)',
        'Нет': 'Нет'
    }


    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar);
            let json = JSON.parse(decode(fetched.ind3));

            fetchData = await fetch();
            width.set(json.width);
            height.set(json.height);
            system = json.system;
            uprav = json.uprav;
            tesma = json.tesma;
            picTesma = json.picTesma;
            cvetTesma1 = json.cvetTesma1;
            cvetTesma2 = json.cvetTesma2;
            park = json.park;
            tipTkan1 = json.tipTkan1;
            tipTkan2 = json.tipTkan2;
            cvetTkan1 = json.cvetTkan1;
            cvetTkan2 = json.cvetTkan2;
            distance = json.distance;
            kant = json.kant;
            pult = json.pult;
            dopupr = json.dopupr;
            sterj = json.sterj;
            tipTkanKant = json.tipTkanKant;
            cvetTkanKant = json.cvetTkanKant;
            solnbat = json.solnbat;
            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    const fetch = async () => {
        let result = await network.fetch_data('Римские шторы', 'Римские шторы', '');
        let tesma = result.filter(el => el.name.startsWith('Тесьма') && el.flag === '1')
        let tkan = result.filter(el => el.name.startsWith('Ткань') && el.flag === '1')

        // Создаем маппинг тип ткани -> доступные цвета
        const tipTkanToCvetTkan = {};

        tkan.forEach(el => {
            const tkanName = el.ind1.trim().capitalize();
            const cvetTkan = el.ind2.trim().capitalize();

            if (!tipTkanToCvetTkan[tkanName]) {
                tipTkanToCvetTkan[tkanName] = new Set();
            }
            tipTkanToCvetTkan[tkanName].add(cvetTkan);
        });


        return {
            name: _.groupBy(result, 'name'),
            cvetTesma1: Array.from(new Set(tesma.map(el => el.name.trim().capitalize()).sort((a, b) => a.localeCompare(b)))),
            tipTkan: Array.from(new Set(tkan.map(el => el.ind1.trim().capitalize()).sort((a, b) => a.localeCompare(b)))),
            cvetTkan: Array.from(new Set(tkan.map(el => el.ind2.trim().capitalize()).sort((a, b) => a.localeCompare(b)))),
            tipTkanToCvetTkan: tipTkanToCvetTkan,
            result,
        }
    }

    let
        width = parameter('width', '1000'),
        height = parameter('height', '1500'),
        system = 'Стандарт ГИ',
        uprav = 'Левое',
        tesma = 'Нет',
        picTesma = 'Виктория',
        cvetTesma1 = '',
        cvetTesma2 = '',
        park = '',
        tipTkan1 = '1',
        tipTkan2 = '',
        cvetTkan1 = '',
        cvetTkan2 = '',
        distance = 'Стандарт 30 см',
        kant = 'Нет',
        pult = 'Пульт Novo А13 (6 каналов)',
        dopupr = 'Нет',
        sterj = 'Нет',
        solnbat = 'Нет',
        tipTkanKant = '',
        cvetTkanKant = '',


        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1),

        cvetTesma1Img = '',
        cvetTesma2Img = ''
    ;

    let fetchData = fetch();
    // let
    // montage_item,
    // montage_price = 1;
   // расчёт стоимости




    $: system, uprav, tesma, picTesma, cvetTesma1, cvetTesma2, park,
        tipTkan1, tipTkan2, cvetTkan1, cvetTkan2,
        distance, kant, pult, dopupr, sterj,
        tipTkanKant, cvetTkanKant, solnbat,
        $width, $height, $count, $comment,
        change();


    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,
            w = +$width,
            h = +$height;

        let title = [
            system, ' ', w + 'x' + h,
            ' ',
            uprav,
            ...(!system.includes('без ткани') ? [' ', cvetTkan1] : []),
            ...(system.includes('День-ночь') ? [', ', cvetTkan2] : []),
            ...((tesma !== 'Нет'||kant !== 'Нет' ) ? [', ', picTesma] : []),
            ...(tesma !== 'Нет' ? [', тесьма ', tesma, cvetTesma1] : []),
            ...(tesma !== 'Две' ? [', ', cvetTesma2] : []),
            ...(kant !== 'Нет' ? [', ', kant, ', ', tipTkanKant, ', ', cvetTkanKant] : []),
            ...(system.includes('ГИ') ? [', ', park] : []),
            ' между стержнями ', distance, ' количество ', sterj,
            ...((system.includes('220В') || system.includes('АКБ')) ? [', ', pult,', ', dopupr, ', ', solnbat, ] : []),
        ].join('')

        let result = {
            type: 'Стандарт ГИ',
            name: 'Стандарт ГИ',
            subname: 'Римские шторы' + [system, ' ', w + 'x' + h],
            title,
            params: {
                ind1: [
                    system, ' ', w + 'x' + h
                ].join(''),
                ind2: '', // цвет
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    system,
                    uprav,
                    tesma,
                    picTesma,
                    cvetTesma1,
                    cvetTesma2,
                    park,
                    tipTkan1,
                    tipTkan2,
                    cvetTkan1,
                    cvetTkan2,
                    distance,
                    kant,
                    pult,
                    dopupr,
                    sterj,
                    tipTkanKant,
                    cvetTkanKant,
                    solnbat,
                    // podves,
                    // razdvizka,
                    // begun,

                    // dop_uprav,
                })),
                ind4: w,
                ind5: h,
            },

            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: 152, //категория в которую посчитанные изделия
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (name === cvetTesma1.toLowerCase()) {

                cvetTesma1Img = item.foto_small;

            }

            if (name === cvetTesma2.toLowerCase()) {

                cvetTesma2Img = item.foto_small;

            }


            if (name === 'Карниз для римской шторы'.toLowerCase() && !system.includes('День-ночь')){
                kolvo = (w / 1000).toFixed(3);
            }

            if (name === 'Карниз для римской шторы День-ночь'.toLowerCase() &&  system.includes('День-ночь')){
                    kolvo = (w / 1000).toFixed(3);
            }


            if (name === 'Стержень управления для римской шторы'.toLowerCase() && !system.includes('День-ночь')) {

                kolvo = (w / 1000 ).toFixed(3);
            }
            if (name === 'Стержень для римской шторы День-ночь'.toLowerCase() && system.includes('День-ночь')) {

                kolvo = (w / 1000 * 2 ).toFixed(3);
            }

            //если указано количество стрежней, то ширина * кол-во стрежней,
            // иначе (округление до большего целого высота / 300) * ширину
            if (name === 'Фиберглассовый стержень'.toLowerCase() || (name === 'Лента HESTIA'.toLowerCase() && !system.includes('без ткани'))) {

                let k = 1;
                if (system.includes('День-ночь')){
                    k = 2
                }

                if (system.includes('без ткани') ) {

                    if (sterj != 'Нет') {
                    kolvo = (sterj * w / 1000 * k ).toFixed(3);
                    } else {
                        kolvo=0;
                    }

                } else {
                    kolvo = (Math.ceil((h / 300) - 1) * w / 1000 * k ).toFixed(3);
                }
            }



            if (name === 'Отвес для римки'.toLowerCase()) {
                let k = 1;
                if (system.includes('День-ночь')){
                    k = 2
                }
                kolvo = (w / 1000 * k).toFixed(3);
            }

            // если карниз без ткани, то равно 0, иначе А
            if (!system.includes('без ткани') && name === 'Пошив римки + Hestia'.toLowerCase()) {
                let k = 1;
                if (system.includes('День-ночь')){
                    k = 2
                }

                if (system.includes('без ткани') && sterj != 'Нет') {
                    kolvo = (h / 1000 * w / 1000 * k ).toFixed(3);
                }
                if (!system.includes('без ткани')) {
                    kolvo = (h / 1000 * w / 1000 * k).toFixed(3);
                }
            }

            /* <option value="Виктория">Виктория</option>
             <option value="Горизонт">Горизонт</option>
             <option value="Джестер">Джестер</option>
             <option value="Кинг">Кинг</option>
             <option value="Стрим">Стрим</option>
             <option value="Чесс">Чесс</option>
             */


            if ((name === cvetTesma1.toLowerCase() || (name === cvetTesma2.toLowerCase() && tesma == 'Две')) && !system.includes('без ткани') && tesma !== 'Нет') {

                let koof = 1
                if (cvetTesma1 == cvetTesma2) {
                    koof = 2
                }

                if (picTesma == 'Виктория') {
                    kolvo = (koof * (w / 1000 + 2 * h / 1000)).toFixed(3);
                } else if (picTesma == 'Горизонт') {
                    kolvo = (koof * 2 * w / 1000).toFixed(3);
                } else if (picTesma == 'Джестер' || picTesma == 'Кинг') {
                    kolvo = (koof * w / 1000).toFixed(3);
                } else if (picTesma == 'Стрим') {
                    kolvo = (koof * 2 * h / 1000).toFixed(3);
                } else {
                    kolvo = (koof * (2 * w / 1000 + 2 * h / 1000)).toFixed(3);
                }
            }


            if (!system.includes('без ткани') && name === 'Пошив тесьмы'.toLowerCase() && tesma !== 'Нет') {
                let koof = 1
                if (tesma == 'Две') {
                    koof = 2
                }

                if (picTesma == 'Виктория') {
                    kolvo = (koof * (w / 1000 + 2 * h / 1000)).toFixed(3);
                } else if (picTesma == 'Горизонт') {
                    kolvo = (koof * 2 * w / 1000).toFixed(3);
                } else if (picTesma == 'Джестер' || picTesma == 'Кинг') {
                    kolvo = (koof * w / 1000).toFixed(3);
                } else if (picTesma == 'Стрим') {
                    kolvo = (koof * 2 * h / 1000).toFixed(3);
                } else {
                    kolvo = (koof * (2 * w / 1000 + 2 * h / 1000)).toFixed(3);
                }
            }


            if (!system.includes('без ткани') && (name === 'ткань ' + cvetTkan1.toLowerCase())) {
                kolvo = (Math.ceil(h / 1000)).toFixed(3);
            }

            if (!system.includes('без ткани') && (name === 'ткань ' + cvetTkan2.toLowerCase()) && system.includes('День-ночь')) {
                kolvo = (Math.ceil(h / 1000)).toFixed(3);
            }


            if (!system.includes('без ткани') && (name === 'ткань ' + cvetTkanKant.toLowerCase()) && kant !== 'Нет') {
                kolvo = (1).toFixed(3);
            }

            if (!system.includes('без ткани') && name === 'Пошив канта'.toLowerCase() && kant !== 'Нет') {
                let k = 1;
                if (system.includes('День-ночь')){
                    k = 2
                }

                if (picTesma == 'Виктория') {
                    kolvo = (w / 1000 + 2 * h / 1000  * k).toFixed(3);
                } else if (picTesma == 'Горизонт') {
                    kolvo = (2 * w / 1000  * k).toFixed(3);
                } else if (picTesma == 'Джестер' || picTesma == 'Кинг') {
                    kolvo = (w / 1000  * k).toFixed(3);
                } else if (picTesma == 'Стрим') {
                    kolvo = (2 * h / 1000  * k).toFixed(3);
                } else {
                    kolvo = (2 * w / 1000 + 2 * h / 1000  * k).toFixed(3);
                }
            }

            //если карниз без ткани, то равно 0, иначе А*В  kolvo = ((h / 300 - 1) * w / 1000).toFixed(3);
            if (name === 'Крючек для римских штор'.toLowerCase()) {

                let k = 1;
                if (system.includes('День-ночь')){
                    k = 2
                }

                if (!system.includes('без ткани')) {
                    if (w < 1000) {
                        kolvo = (Math.ceil(h / 300 - 1 ) * 2 * k).toFixed(3);
                    } else if (w < 2000) {
                        kolvo = (Math.ceil(h / 300 - 1 )  * 4 * k).toFixed(3);
                    } else {
                        kolvo = (Math.ceil(h / 300 - 1 )  * 6* k).toFixed(3);
                    }
                }
            }

            //Если ширина от 0 до 1000, тогда 2 шт. От 1001 до 2000, тогда 4 шт. От 2001 и до 2800 тогда 6 шт.
            if (
                (name === 'Шнуронамотка'.toLowerCase()  && (!system.includes('День-ночь')))
                || (name === 'Шнуронамотка римской шторы День-Ночь'.toLowerCase() && (system.includes('День-ночь')))
                || ((!system.includes('День-ночь')) && name === 'Кронштейн для римской шторы'.toLowerCase())
                || ((system.includes('День-ночь')) && name === 'Кронштейн день ночь для римской шторы'.toLowerCase())) {
                let k = 1;
                if (system.includes('День-ночь')){
                    k = 2
                }
                if (w < 1000) {
                    kolvo = 2 * k;
                } else if (w < 2000) {
                    kolvo = 4 * k;
                } else {
                    kolvo = 6 * k;
                }
            }

            //если римка стандарт ГИ / карниз без ткани, тогда 1.
            // Если римка день ночь ГИ / День-ночь без ткани, тогда 2.
            // Если Римская 220В ГИ / Римская АКБ ГИ / Карниз без ткани 220В / Карниз без ткани АКБ, тогда 0.
            if (name === 'Механизм'.toLowerCase() && !system.includes('без ткани') && (!system.includes('День-ночь'))) {
                kolvo = (1).toFixed(3);
            }

            if (name === 'Механизм'.toLowerCase() && !system.includes('без ткани') && (system.includes('День-ночь'))) {
                kolvo = (1).toFixed(3);

            }
            //равно С * высота * 2 -600
            if (name === 'Цепь управления металл'.toLowerCase()  ) {

                if (system.includes('День-ночь')){
                    kolvo = (2 * (h * 2 - 600) / 1000).toFixed(3);
                }
                else{
                    kolvo = ((h * 2 - 600) / 1000).toFixed(3);
                }
            }


            if (name === 'Мотор для римки Novo 220В'.toLowerCase() && system.includes('220В')) {
                kolvo = (1).toFixed(3);
            }

            if (name === 'Адаптер питания Novo для римки 220В'.toLowerCase() && system.includes('220В')) {
                kolvo = (1).toFixed(3);
            }

            if (name === pult.toLowerCase() && (system.includes('220В') || system.includes('АКБ'))) {
                kolvo = (1).toFixed(3);
            }

            if (name === dopupr.toLowerCase() && (system.includes('220В') || system.includes('АКБ'))) {
                kolvo = (1).toFixed(3);
            }

            //Карниз без ткани АКБ / Римская АКБ ГИ, тогда 1 иначе 0
            if (name === 'Мотор для римки АКБ А-ОК'.toLowerCase() && system.includes('АКБ')) {
                kolvo = (1).toFixed(3);
            }

            if (name === 'АКБ для римки А-ОК'.toLowerCase() && (system === 'Карниз без ткани АКБ' || system === 'Римская АКБ ГИ')) {
                kolvo = (1).toFixed(3);
            }

            if (name === 'Солнечная панель'.toLowerCase() && (solnbat=='Да') && system.includes('АКБ')) {
                kolvo = (1).toFixed(3);
            }


            if (  (name === 'сборка римской ' + system.toLowerCase() || name === 'сборка ' + system.toLowerCase())) {
                kolvo = (1).toFixed(3);
            }


            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }


        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        dispatch('item', result);
    }, 250);

    change();

    let filteredCvetTkan1 = []; // Отфильтрованные значения для первого селекта
    let filteredCvetTkan2 = []; // Отфильтрованные значения для второго селекта
    let filteredCvetTkanKant = []; // Отфильтрованные значения для второго селекта

    // Инициализация отфильтрованных значений после загрузки данных
    const initializeFilteredValues = async () => {
        const data = await fetchData;

        if (data.cvetTkan) {
            filteredCvetTkan1 = [...data.cvetTkan];
            filteredCvetTkan2 = [...data.cvetTkan];
            filteredCvetTkanKant = [...data.cvetTkan];

            // Применяем фильтрацию если уже выбраны ткани
            if (cvetTkan1) {
                await filterСvetTkan1();
            }
            if (cvetTkan2) {
                await filterСvetTkan2();
            }
        }
    };

    // Обработчик изменения первой ткани
    const handleTipTkan1Change = (event) => {
        cvetTkan1 = event.target.value;
        filterСvetTkan1();
        change();
    };

    // Обработчик изменения второй ткани
    const handleTipTkan2Change = (event) => {
        cvetTkan2 = event.target.value;
        filterСvetTkan2();
        change();
    };

    // Обработчик изменения второй ткани
    const handleTipTkanKantChange = (event) => {
        cvetTkanKant = event.target.value;
        filterСvetTkanKant();
        change();
    };


    const filterСvetTkan1 = async () => {
        const data = await fetchData;

        if (!tipTkan1 || !data.tipTkanToCvetTkan) {
            // Если ничего не выбрано, показываем все цвета
            filteredCvetTkan1 = data.cvetTkan || [];
            return;
        }

        // Получаем доступные цвета для выбранной ткани
        const availableCveta = data.tipTkanToCvetTkan[tipTkan1] || new Set();


        filteredCvetTkan1 = (data.cvetTkan || []).filter(cveta =>
            availableCveta.has(cveta)
        );

        // Если есть доступные цвета, выбираем первую
        if (filteredCvetTkan1.length > 0 && !availableCveta.has(cvetTkan1)) {
            cvetTkan1 = filteredCvetTkan1[0];
        } else if (filteredCvetTkan1.length === 0) {
            cvetTkan1 = '';
        }
    };

    const filterСvetTkan2 = async () => {
        const data = await fetchData;

        if (!tipTkan2 || !data.tipTkanToCvetTkan) {
            // Если ничего не выбрано, показываем все цвета
            filteredCvetTkan2 = data.cvetTkan || [];
            return;
        }

        // Получаем доступные цвета для выбранной ткани
        const availableCveta = data.tipTkanToCvetTkan[tipTkan2] || new Set();


        filteredCvetTkan2 = (data.cvetTkan || []).filter(cveta =>
            availableCveta.has(cveta)
        );

        // Если есть доступные цвета, выбираем первую
        if (filteredCvetTkan2.length > 0 && !availableCveta.has(cvetTkan2)) {
            cvetTkan2 = filteredCvetTkan2[0];
        } else if (filteredCornice2.length === 0) {
            cvetTkan2 = '';
        }
    };

    const filterСvetTkanKant = async () => {
        const data = await fetchData;

        if (!tipTkanKant || !data.tipTkanToCvetTkan) {
            // Если ничего не выбрано, показываем все цвета
            filteredCvetTkanKant = data.cvetTkan || [];
            return;
        }

        // Получаем доступные цвета для выбранной ткани
        const availableCveta = data.tipTkanToCvetTkan[tipTkanKant] || new Set();


        filteredCvetTkanKant = (data.cvetTkan || []).filter(cveta =>
            availableCveta.has(cveta)
        );

        // Если есть доступные цвета, выбираем первую
        if (filteredCvetTkanKant.length > 0 && !availableCveta.has(cvetTkanKant)) {
            cvetTkanKant = filteredCvetTkanKant[0];
        } else if (filteredCornice2.length === 0) {
            cvetTkanKant = '';
        }
    };

</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!-- <pre>{JSON.stringify(data, null, 4)}</pre>-->

    <style>
        .parent {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-auto-rows: auto;
            grid-column-gap: 5px;
            grid-row-gap: 0px;
            grid-template-areas:

                 "system uprav"
                 "width height"
                 "pult dopupr"
                 "tipTkan1 cvetTkan1"
                 "tipTkan2 cvetTkan2"
                 "kant tesma"
                 "sterj picTesma"
                 "tipTkanKant cvetTkanKant"
                 "cvetTesma1 cvetTesma2"
                 "distance park"
                 ". solnbat"
                 "comment comment"
                 "picTesmaImg picTesmaImg"
                 "picCvetTesma1 picCvetTesma1"
                 "picCvetTesma2 picCvetTesma2"


        }


        @media (min-width: 575.98px) {
            .parent {
                grid-template-columns: repeat(3, 1fr);
                grid-template-areas:
                    "picTesmaImg system uprav"
                    "picTesmaImg width height"
                    "picTesmaImg pult dopupr"
                    "picTesmaImg tipTkan1 cvetTkan1"
                    "picTesmaImg tipTkan2 cvetTkan2"
                    "picCvetTesma1 kant tesma"
                    "picCvetTesma1 sterj picTesma"
                    "picCvetTesma2 tipTkanKant cvetTkanKant"
                    "picCvetTesma2 cvetTesma1 cvetTesma2"
                    ". distance park"
                    ". . solnbat"
                    "comment comment comment"
            }

        }

        .kant {
            grid-area: kant;
        }

        .pult {
            grid-area: pult;
        }

        .dopupr {
            grid-area: dopupr;
        }

        .sterj {
            grid-area: sterj;
        }

        .system {
            grid-area: system;
        }

        .uprav {
            grid-area: uprav;
        }

        .width {
            grid-area: width;
        }

        .height {
            grid-area: height;
        }

        .tesma {
            grid-area: tesma;
        }

        .cvetTesma1 {
            grid-area: cvetTesma1;
        }

        .cvetTesma2 {
            grid-area: cvetTesma2;
        }


        .picCvetTesma1 {
            grid-area: picCvetTesma1;
        }

        .picCvetTesma2 {
            grid-area: picCvetTesma2;
        }

        .comment {
            grid-area: comment;
        }

        .tipTkan1 {
            grid-area: tipTkan1;
        }

        .tipTkan2 {
            grid-area: tipTkan2;
        }

        .cvetTkan1 {
            grid-area: cvetTkan1;
        }

        .cvetTkan2 {
            grid-area: cvetTkan2;
        }

        .picTesmaImg {
            grid-area: picTesmaImg;
        }

        .picTesma {
            grid-area: picTesma;
        }

        .distance {
            grid-area: distance;
        }

        .tipTkanKant {
            grid-area: tipTkanKant;
        }

        .cvetTkanKant {
            grid-area: cvetTkanKant;
        }

        .park {
            grid-area: park;
        }

        .solnbat {
            grid-area: solnbat;
        }




    </style>
    <div class="card-body" >

        <div class='parent'>
            <div class="system">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Система </label>
                        <select class="form-control form-select" bind:value={system}>
                            <option value="Стандарт ГИ">Стандарт ГИ</option>
                            <option value="День-ночь ГИ">День-ночь ГИ</option>
                            <option value="Римская 220В ГИ">Римская 220В ГИ</option>
                            <option value="Римская АКБ ГИ">Римская АКБ ГИ</option>
                            <option value="Карниз без ткани">Карниз без ткани</option>
                            <option value="Карниз без ткани 220В">Карниз без ткани 220В</option>
                            <option value="Карниз без ткани АКБ">Карниз без ткани АКБ</option>
                            <option value="День-ночь без ткани">День-ночь без ткани</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="uprav">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Управление\подключение</label>
                        <select class="form-control form-select" bind:value={uprav}>
                            <option value="Левое">Левое</option>
                            <option value="Правое">Правое</option>
                        </select>
                    </div>
                </div>
            </div>

            {#if (system.includes('220В') || system.includes('АКБ'))}
                <div class="pult">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Пульт управления</label>
                            <select class="form-control form-select" bind:value={pult}>

                                {#if system.includes('220')}
                                <option value="Пульт Novo А13 (6 каналов)">Пульт Novo А13 (6 каналов)</option>
                                <option value="Пульт Novo А6 (9 каналов)">Пульт Novo А6 (9 каналов)</option>
                                <option value="Пульт Novo А6 (99 каналов)">Пульт Novo А6 (99 каналов)</option>
                                    <option value="Нет">Нет</option>
                                {/if}
                                {#if system.includes('АКБ')}
                                <option value="Пульт А-ОК">Пульт А-ОК</option>



                                <option value="Нет">Нет</option>
                                {/if}
                            </select>
                        </div>
                    </div>
                </div>

                <div class="dopupr">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Доп управление</label>
                            <select class="form-control form-select" bind:value={dopupr}>
                                <option value="Кнопка Novo А9 (1 канал белая)">Кнопка Novo А9 (1 канал белая)</option>
                                <option value="Кнопка Novo А9 (2 канала белая)">Кнопка Novo А9 (2 канала белая)</option>
                                <option value="Кнопка Novo А9 (1 канал черная)">Кнопка Novo А9 (1 канал черная)</option>
                                <option value="Кнопка Novo А9 2 (канал черная)">Кнопка Novo А9 2 (канал черная)</option>
                                <option value="Wi-Fi блок Novo для Алисы">Wi-Fi блок Novo для Алисы</option>
                                <option value="Нет">Нет</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}


            {#if system.includes('АКБ')}
                <div class="solnbat">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Солнечная панель</label>
                            <select class="form-control form-select" bind:value={solnbat}>
                                <option value="Да">Да</option>
                                <option value="Нет">Нет</option>
                            </select>
                        </div>
                    </div>
                </div>

            {/if}

            <div class="width">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Ширина, мм</label>
                        <input type="number"
                               class="form-control text-center"
                               step="1"
                               bind:value={$width}>
                    </div>
                </div>
            </div>

            <div class="height">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Высота, мм</label>
                        <input type="number"
                               class="form-control text-center"
                               step="1"
                               bind:value={$height}>
                    </div>
                </div>
            </div>

            {#if !system.includes('без ткани')}

                <div class="tipTkan1">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Ткань</label>
                            <select class="form-control form-select" bind:value={tipTkan1}
                                    on:change={handleTipTkan1Change}  >
                                {#each data.tipTkan as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>

                <div class="cvetTkan1">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Цвет ткани</label>
                            <select class="form-control form-select" bind:value={cvetTkan1}  >
                                {#each filteredCvetTkan1 as value}
                                    <option value="{value}">{value}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>

                {#if system.includes('День-ночь')}

                    <div class="tipTkan2">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ткань на 2-ю римку</label>
                                <select class="form-control form-select" bind:value={tipTkan2}
                                        on:change={handleTipTkan2Change}>
                                    {#each data.tipTkan as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="cvetTkan2">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет ткани на 2-ю римку</label>
                                <select class="form-control form-select" bind:value={cvetTkan2}>
                                    {#each filteredCvetTkan2 as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                {/if}


                {#if kant != 'Нет'}

                    <div class="tipTkanKant">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Ткань на кант</label>
                                <select class="form-control form-select" bind:value={tipTkanKant}
                                        on:change={handleTipTkanKantChange}>
                                    {#each data.tipTkan as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="cvetTkanKant">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Цвет ткани на кант</label>
                                <select class="form-control form-select" bind:value={cvetTkanKant}>
                                    {#each filteredCvetTkanKant as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>

                {/if}

                <div class="tesma">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Тесьма</label>
                            <select class="form-control form-select" bind:value={tesma}>
                                <option value="Нет">Нет</option>
                                <option value="Одна">Одна</option>
                                <option value="Две">Две</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="kant">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Кант</label>
                            <select class="form-control form-select" bind:value={kant}>
                                <option value="Есть">Есть</option>
                                <option value="Нет">Нет</option>
                            </select>
                        </div>
                    </div>
                </div>

                {#if tesma !== 'Нет'}

                    <div class="cvetTesma1">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тесьма цвет 1</label>
                                <select class="form-control form-select" bind:value={cvetTesma1}>
                                    {#each data.cvetTesma1 as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>


                    {#if cvetTesma1Img }
                        <div class="picCvetTesma1 text-center">
                            <img src={'https://225304.selcdn.ru/axisdb/'+ cvetTesma1Img} alt={cvetTesma1}
                                 title={cvetTesma1}
                                 style="width: 200px"/>
                            <div class="text-center">
                                <span class="form-label text-center">Цвет тесьмы 1</span>
                            </div>
                        </div>
                    {/if}

                {/if}

                {#if tesma === 'Две'}

                    <div class="cvetTesma2">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Тесьма цвет 2</label>
                                <select class="form-control form-select" bind:value={cvetTesma2}>
                                    {#each data.cvetTesma1 as value}
                                        <option value="{value}">{value}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>


                    {#if cvetTesma2Img}
                        <div class="picCvetTesma2 text-center">
                            <img src={'https://225304.selcdn.ru/axisdb/'+ cvetTesma2Img} alt={cvetTesma2}
                                 title={cvetTesma2}
                                 style="width: 200px"/>
                            <div class="text-center">
                                <span class="form-label text-center">Цвет тесьмы 2</span>
                            </div>
                        </div>
                    {/if}

                {/if}

                <div class="distance">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Между стержнями</label>
                            <select class="form-control form-select" bind:value={distance}>
                                <option value="Стандарт 30 см">Стандарт 30 см</option>
                                <option value="20 см">20 см</option>
                                <option value="25 см">25 см</option>
                                <option value="35 см">35 см</option>
                                <option value="40 см">40 см</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            {#if system.includes('без ткани')}
                <div class="sterj">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Кол-во стержней</label>
                            <select class="form-control form-select" bind:value={sterj}>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="Нет">Нет</option>
                            </select>
                        </div>
                    </div>
                </div>
            {/if}

            {#if !system.includes('без ткани')}
                {#if (tesma !== 'Нет' || kant !== 'Нет') }
                    <div class="picTesma">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Рисунок</label>
                                <select class="form-control form-select" bind:value={picTesma}>
                                    <option value="Виктория">Виктория</option>
                                    <option value="Горизонт">Горизонт</option>
                                    <option value="Джестер">Джестер</option>
                                    <option value="Кинг">Кинг</option>
                                    <option value="Стрим">Стрим</option>
                                    <option value="Чесс">Чесс</option>
                                </select>
                            </div>
                        </div>
                    </div>
                {/if}


                {#if picTesma }
                    {@const upr = system?.includes('АКБ')
                        ? 'АКБ'
                        : system?.includes('220')
                            ? '220'
                            : uprav === 'Левое'
                                ? 'цепь-л'
                                : uprav === 'Правое'
                                    ? 'цепь-пр'
                                    : ''}
                    {@const knt = kant == 'Нет'
                        ? 'Нет'
                        : 'Да'}

                    {@const pic = (tesma == 'Нет' && kant == 'Нет')
                        ? 'нет'
                        : picTesma}

                    {#if upr}
                        <div class="picTesmaImg text-center mt-2">
                            <img src={`/img/other/rimskie/${upr}-${pic}-${knt}-${tesma}.png`}
                                 alt={picTesma}
                                 title={picTesma}
                                 style="width: 200px"/>
                            <div>кол-во стержней {Math.ceil($height / 300) - 1} шт.</div>
                        </div>

                    {/if}


                {/if}

            {/if}

            {#if system.includes('без ткани')}
                {@const upr = system?.includes('АКБ')
                    ? 'АКБ'
                    : system?.includes('220')
                        ? '220'
                        : uprav === 'Левое'
                            ? 'цепь-л'
                            : uprav === 'Правое'
                                ? 'цепь-пр'
                                : ''}
                <div class="picTesmaImg text-center mt-2">
                    <img src={`/img/other/rimskie/${upr}-rs-karniz.png`}
                         alt='карниз без ткани'
                         title='карниз без ткани'
                         style="width: 200px"/>

                </div>
            {/if}

            {#if system.includes('ГИ')}


                <div class="park">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Парковка ткани (мм)</label>
                            <input type="number"
                                   class="form-control text-center"
                                   step="1"
                                   bind:value={park}>
                        </div>
                    </div>
                </div>

            {/if}


            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
{/await}